<template>
  <div class="loginSsoPage loginComponent">
		<h1>Logging In</h1>
		<br>
		<br>
		<v-progress-circular
      :size="70"
      :width="7"
      color="#316094"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
import { authService } from '@/services/authService.js';

export default {
	name: 'LoginSsoPage',
	props: {},
	metaInfo: {
		title: 'Login SSO'
	},
	mounted () {
		this.login();
	},
	methods: {
		login () {
			const token = this.$route.query.token;
			const me = this;
			authService.loginSso(token).then(function () {
				me.$store.dispatch('loginStartup').then(function () {
					me.$router.push('/landing');
				}).catch(function (err) {
					me.handleLoginError(err);
				});
			}).catch(function (err) {
				me.handleLoginError(err);
			});
		},
		handleLoginError (error) {
			console.log('Error logging in', error);
			this.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: 'There was an error logging you in. You will be redirected to the login page. Please contact the help desk.' });
			// Redirect to the login page after 5 seconds so the user can read the error message.
			const me = this;
			setTimeout(function () {
				me.$store.dispatch('logout', { fullClear: true });
			}, 5000);
		}
	}
};
</script>

<style>
</style>
